import { render, staticRenderFns } from "./LoanImportsUpdate.vue?vue&type=template&id=0ba68994"
import script from "./LoanImportsUpdate.vue?vue&type=script&lang=js"
export * from "./LoanImportsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports